// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientSearchResponseModel {
    static getAttributeTypeMap() {
        return PatientSearchResponseModel.attributeTypeMap;
    }
}
PatientSearchResponseModel.discriminator = undefined;
PatientSearchResponseModel.attributeTypeMap = [
    {
        "name": "patients",
        "baseName": "patients",
        "type": "Array<PatientModel>"
    },
    {
        "name": "hasAdditionalMatches",
        "baseName": "hasAdditionalMatches",
        "type": "boolean"
    }
];
//# sourceMappingURL=patientSearchResponseModel.js.map